// @ts-nocheck
import * as actionTypes from './wixAdActionTypes';

const overrideWixAdsBanner = (overrides) => ({
  type: actionTypes.OVERRIDE_WIX_AD,
  overrides,
});

export { overrideWixAdsBanner };
